import { type Dispatch, createContext } from 'react';

import { FormFieldReducerAction } from '../state/formfield-state-reducer.js';

/**
 * Common, optional, input-related child nodes props to be bound in input elements and its siblings.
 * @public
 */
export interface SharedFormFieldProps {
  /** An id for the form control (also needed to link the label). */
  controlId?: string;
  /**
   * Defines if any form control within the FormField is required.
   * @defaultValue false
   */
  required?: boolean;
  /**
   * Defines if any form control within the FormField is disabled.
   * @defaultValue false
   */
  disabled?: boolean;
  /**
   * Defines if any form control within the FormField is aria-disabled.
   */
  ariaDisabled?: boolean;
}

/**
 * @public
 */
export interface SharedFormFieldContextProps extends SharedFormFieldProps {
  dispatch?: Dispatch<FormFieldReducerAction>;
}

/**
 * @internal
 * Context provider for `FormField` props meant to be provided to all its input-related child nodes.
 */
export const _FormFieldContext = createContext<SharedFormFieldContextProps>({
  controlId: undefined,
  required: undefined,
  disabled: undefined,
  ariaDisabled: undefined,
  dispatch: undefined,
});
